import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { api } from '../api.js';
import { useAuth } from '../auth.jsx';

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [insts, setInsts] = useState([]);
  const [form, setForm] = useState({ institution_id: '', username: '', password: '' });
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => { api.institutions().then(setInsts); }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.institution_id) {
      setErr('먼저 소속 기관을 선택해 주세요.');
      return;
    }
    setErr(''); setLoading(true);
    try {
      await login({
        institution_id: Number(form.institution_id),
        username: form.username.trim(),
        password: form.password,
      });
      nav('/');
    } catch (e) {
      setErr(e.message);
    } finally { setLoading(false); }
  };

  const onCredFocus = (e) => {
    if (!form.institution_id) {
      setErr('먼저 위에서 소속 기관을 선택해 주세요.');
      e.target.blur();
    }
  };

  const selectedInst = insts.find(i => i.id === Number(form.institution_id));

  return (
    <div className="min-h-[calc(100vh-64px)] flex items-center justify-center px-4 py-10 bg-gradient-to-b from-white to-medical-50">
      <div className="w-full max-w-2xl">
        <div className="text-center mb-6">
          <img src="/logo.jpg" alt="K-BIORIA" className="h-12 mx-auto" />
          <h1 className="text-2xl font-bold text-medical-800 mt-3">리소스공유 포털</h1>
          <p className="text-sm text-medical-500 mt-1">소속을 선택하고 로그인하세요</p>
        </div>
        <form onSubmit={submit} className="bg-white rounded-2xl shadow-card p-7 border border-medical-100">
          <label className="text-sm font-semibold text-medical-700 flex items-center gap-1">
            소속 기관 <span className="text-red-500">*</span>
            {!form.institution_id && <span className="ml-2 text-xs font-normal text-red-600">먼저 기관을 선택하세요</span>}
          </label>
          <div className="mt-2 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-2 mb-3">
            {insts.map(i => (
              <button type="button" key={i.id}
                onClick={() => setForm({ ...form, institution_id: i.id })}
                className={'flex flex-col items-center justify-start gap-1.5 px-2 py-3 rounded-lg border text-xs leading-tight text-center min-h-[96px] ' +
                  (Number(form.institution_id) === i.id
                    ? 'border-medical-500 bg-medical-50 text-medical-800 font-semibold ring-2 ring-medical-200'
                    : 'border-medical-100 text-medical-700 hover:bg-medical-50')}>
                <img src={'/institutions/' + i.logo_path} alt={i.name} className="h-10 w-10 object-contain" />
                <span className="break-keep whitespace-normal">{i.name}</span>
              </button>
            ))}
          </div>
          {selectedInst ? (
            <div className="text-xs text-medical-700 bg-medical-50 border border-medical-100 rounded px-2 py-1 mb-3">
              선택됨: <b>{selectedInst.name}</b>
            </div>
          ) : (
            <div className="text-xs text-red-600 bg-red-50 border border-red-100 rounded px-2 py-1 mb-3">
              ⚠ 위에서 소속 기관을 먼저 선택해 주세요. 선택해야 아이디/비밀번호를 입력할 수 있습니다.
            </div>
          )}
          <label className={'text-sm font-semibold ' + (form.institution_id ? 'text-medical-700' : 'text-medical-400')}>아이디</label>
          <input className="w-full mt-1 mb-3 px-3 py-2 border border-medical-200 rounded-md focus:outline-none focus:ring-2 focus:ring-medical-300 disabled:bg-medical-50 disabled:text-medical-400 disabled:cursor-not-allowed"
            value={form.username}
            onFocus={onCredFocus}
            onChange={e => setForm({ ...form, username: e.target.value })}
            disabled={!form.institution_id}
            placeholder={form.institution_id ? '' : '먼저 기관을 선택하세요'}
            required />
          <label className={'text-sm font-semibold ' + (form.institution_id ? 'text-medical-700' : 'text-medical-400')}>비밀번호</label>
          <input type="password" className="w-full mt-1 mb-3 px-3 py-2 border border-medical-200 rounded-md focus:outline-none focus:ring-2 focus:ring-medical-300 disabled:bg-medical-50 disabled:text-medical-400 disabled:cursor-not-allowed"
            value={form.password}
            onFocus={onCredFocus}
            onChange={e => setForm({ ...form, password: e.target.value })}
            disabled={!form.institution_id}
            placeholder={form.institution_id ? '' : '먼저 기관을 선택하세요'}
            required />
          {err && <div className="text-sm text-red-600 mb-3">{err}</div>}
          <button disabled={loading || !form.institution_id}
            title={!form.institution_id ? '먼저 소속 기관을 선택하세요' : ''}
            className="w-full bg-medical-600 hover:bg-medical-700 text-white font-semibold py-2.5 rounded-md disabled:opacity-60 disabled:cursor-not-allowed">
            {loading ? '로그인 중...' : (form.institution_id ? '로그인' : '먼저 기관을 선택하세요')}
          </button>
          <div className="text-center text-sm mt-3">
            <Link to="/forgot" className="text-medical-600 hover:underline">비밀번호 찾기</Link>
          </div>
        </form>
        <p className="text-center text-xs text-medical-400 mt-4">
          5개 참여기관 공동 운영
        </p>
      </div>
    </div>
  );
}
